"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.IconWithLabel = exports.StyledIcon = exports.Root = void 0;
const styles_1 = require("@mui/material/styles");
const button_1 = __importDefault(require("../../button"));
const Icon_1 = __importDefault(require("../../icon/Icon"));
const Typography_1 = __importDefault(require("../../typography/Typography"));
exports.Root = (0, styles_1.styled)(button_1.default)(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "64px",
    justifyContent: "center",
    padding: "11px 0",
    width: "87px",
    [theme.breakpoints.up("lg")]: {
        height: "76px",
        padding: "13px 0",
        width: "94px"
    }
}));
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)(({ theme }) => ({
    fill: theme.colours.white
}));
exports.IconWithLabel = (0, styles_1.styled)(exports.StyledIcon)(({ theme }) => ({
    flexShrink: 0,
    height: "16px",
    marginBottom: "4px",
    width: "16px",
    [theme.breakpoints.up("lg")]: {
        marginBottom: "10px"
    }
}));
exports.Label = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.colours.white,
    fontSize: "14px",
    margin: 0,
    [theme.breakpoints.up("lg")]: {
        fontSize: "18px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21lZGlhLWdhbGxlcnkvTWVkaWFCdXR0b24vc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5QywwREFBa0M7QUFDbEMsMkRBQW1DO0FBQ25DLDZFQUFxRDtBQUV4QyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxnQkFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2pELFVBQVUsRUFBRSxRQUFRO0lBQ3BCLE9BQU8sRUFBRSxNQUFNO0lBQ2YsYUFBYSxFQUFFLFFBQVE7SUFDdkIsTUFBTSxFQUFFLE1BQU07SUFDZCxjQUFjLEVBQUUsUUFBUTtJQUN4QixPQUFPLEVBQUUsUUFBUTtJQUNqQixLQUFLLEVBQUUsTUFBTTtJQUNiLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixNQUFNLEVBQUUsTUFBTTtRQUNkLE9BQU8sRUFBRSxRQUFRO1FBQ2pCLEtBQUssRUFBRSxNQUFNO0tBQ2Q7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsVUFBVSxHQUFHLElBQUEsZUFBTSxFQUFDLGNBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNyRCxJQUFJLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0NBQzFCLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxhQUFhLEdBQUcsSUFBQSxlQUFNLEVBQUMsa0JBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM5RCxVQUFVLEVBQUUsQ0FBQztJQUNiLE1BQU0sRUFBRSxNQUFNO0lBQ2QsWUFBWSxFQUFFLEtBQUs7SUFDbkIsS0FBSyxFQUFFLE1BQU07SUFDYixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsWUFBWSxFQUFFLE1BQU07S0FDckI7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsS0FBSyxHQUFHLElBQUEsZUFBTSxFQUFDLG9CQUFVLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdEQsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUMxQixRQUFRLEVBQUUsTUFBTTtJQUNoQixNQUFNLEVBQUUsQ0FBQztJQUNULENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixRQUFRLEVBQUUsTUFBTTtLQUNqQjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=